import React from 'react';

export function hasLabelText(label) {
    return typeof label === 'string' ? label.trim().length > 0 : !!label;
}

export function getFormItemLabelNode(label, required, labelStyle, withColon) {
    if (!hasLabelText(label)) {
        return undefined;
    }
    const labelText = `${label}`;
    return <span style={labelStyle}>{withColon ? `${labelText}: ` : labelText}</span>;
}
